import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetHistoricalArgroupsQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['bigint']['input'];
  scenarioId: Types.Scalars['bigint']['input'];
  settledPaymentStatuses: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type GetHistoricalArgroupsQuery = { __typename?: 'query_root', argroups: Array<{ __typename?: 'argroups', id: number, status: string, scenario_id?: number | null, createdat: string, algorithm_key?: string | null, run_metadata: object, archarges: Array<{ __typename?: 'archarges', id: number, name: string, notes?: string | null, amount: number, billable_datetime: string, accounting_key?: string | null, active: boolean, argroup_id: number, document_reference_id?: string | null, source_type?: string | null, source_id?: number | null, type: string, argroup: { __typename?: 'argroups', id: number, status: string, createdat: string }, documents: Array<{ __typename?: 'documents', id: number, mime_type: string, name: string, url: string }>, move?: Array<{ __typename?: 'moves', id: number, reference_num?: string | null }> | null, arpaymentdetails: Array<{ __typename?: 'arpaymentdetails', id: number, amount: number, parent: { __typename?: 'arpayments', id: number, status: string } }> }> }> };


export const GetHistoricalArgroupsDocument = gql`
    query getHistoricalArgroups($invoiceId: bigint!, $scenarioId: bigint!, $settledPaymentStatuses: [String!]!) {
  argroups(
    where: {arinvoice_id: {_eq: $invoiceId}, scenario_id: {_eq: $scenarioId}, status: {_eq: "historical"}}
    order_by: {createdat: desc}
  ) {
    id
    status
    scenario_id
    createdat
    algorithm_key
    run_metadata
    archarges(
      where: {active: {_eq: true}, source_type: {_eq: "move"}}
      order_by: {billable_datetime: asc}
    ) {
      id
      name
      notes
      amount
      billable_datetime
      accounting_key
      active
      argroup_id
      argroup {
        id
        status
        createdat
      }
      document_reference_id
      documents {
        id
        mime_type
        name
        url
      }
      source_type
      source_id
      type
      move(where: {active: {_eq: 1}}) {
        id
        reference_num
      }
      arpaymentdetails(where: {parent: {status: {_in: $settledPaymentStatuses}}}) {
        id
        amount
        parent {
          id
          status
        }
      }
    }
  }
}
    `;

/**
 * __useGetHistoricalArgroupsQuery__
 *
 * To run a query within a React component, call `useGetHistoricalArgroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalArgroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalArgroupsQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      scenarioId: // value for 'scenarioId'
 *      settledPaymentStatuses: // value for 'settledPaymentStatuses'
 *   },
 * });
 */
export function useGetHistoricalArgroupsQuery(baseOptions: Apollo.QueryHookOptions<GetHistoricalArgroupsQuery, GetHistoricalArgroupsQueryVariables> & ({ variables: GetHistoricalArgroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricalArgroupsQuery, GetHistoricalArgroupsQueryVariables>(GetHistoricalArgroupsDocument, options);
      }
export function useGetHistoricalArgroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricalArgroupsQuery, GetHistoricalArgroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricalArgroupsQuery, GetHistoricalArgroupsQueryVariables>(GetHistoricalArgroupsDocument, options);
        }
// @ts-ignore
export function useGetHistoricalArgroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHistoricalArgroupsQuery, GetHistoricalArgroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetHistoricalArgroupsQuery, GetHistoricalArgroupsQueryVariables>;
export function useGetHistoricalArgroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHistoricalArgroupsQuery, GetHistoricalArgroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetHistoricalArgroupsQuery | undefined, GetHistoricalArgroupsQueryVariables>;
export function useGetHistoricalArgroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHistoricalArgroupsQuery, GetHistoricalArgroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHistoricalArgroupsQuery, GetHistoricalArgroupsQueryVariables>(GetHistoricalArgroupsDocument, options);
        }
export type GetHistoricalArgroupsQueryHookResult = ReturnType<typeof useGetHistoricalArgroupsQuery>;
export type GetHistoricalArgroupsLazyQueryHookResult = ReturnType<typeof useGetHistoricalArgroupsLazyQuery>;
export type GetHistoricalArgroupsSuspenseQueryHookResult = ReturnType<typeof useGetHistoricalArgroupsSuspenseQuery>;
export type GetHistoricalArgroupsQueryResult = Apollo.QueryResult<GetHistoricalArgroupsQuery, GetHistoricalArgroupsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/invoices/queries/getHistoricalArgroups.query.gql}
 */
export async function getHistoricalArgroups(
  variables: GetHistoricalArgroupsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetHistoricalArgroupsQuery['argroups']>
export async function getHistoricalArgroups(
  variables: GetHistoricalArgroupsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetHistoricalArgroupsQuery>
export async function getHistoricalArgroups(
  variables: GetHistoricalArgroupsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetHistoricalArgroupsQuery['argroups'] | GetHistoricalArgroupsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetHistoricalArgroupsQuery>(
    GetHistoricalArgroupsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.argroups
}